export const isResponseError = (e) => {
    if (e && typeof e === 'object' && 'status' in e) {
        return true;
    }
    return false;
};
export const isObjectWithResponse = (e) => {
    if (e && typeof e === 'object' && 'response' in e) {
        return true;
    }
    return false;
};
export const isResponseWithBody = (e) => {
    if (e && typeof e === 'object' && 'body' in e) {
        return true;
    }
    return false;
};
export const isMessageBody = (e) => {
    if (e && typeof e === 'object' && 'message' in e) {
        return true;
    }
    return false;
};
export const isResponseBodyMessageError = (e) => {
    if (e !== null && typeof e !== 'undefined' && isObjectWithResponse(e) && isResponseWithBody(e.response) && isMessageBody(e.response.body)) {
        return true;
    }
    return false;
};
export const isError = (e) => {
    if (e && typeof e === 'object' && 'message' in e) {
        return true;
    }
    return false;
};
